import React from 'react'

export const TextPreviewCell = (props) => {
  const { dataItem, onRowClick } = props
  return <td onClick={() => onRowClick(props)}>
    <div className="html-content" dangerouslySetInnerHTML={{ __html: dataItem.description}}/>
  </td>
}
